import type { TBannerDefinition } from "./types";

export const BANNERS: Record<TBannerDefinition["id"], TBannerDefinition> = {
  "onboarding-reminder-v1": {
    id: "onboarding-reminder-v1",
    requiredStage: ["onboarding_in_progress"],
    routes: ["/app"],
    title: "Complete your onboarding",
    description: "Finish setting up your company profile to unlock dashboards, chats, and all Fundy features.",
    ctaLabel: "Continue onboarding",
    ctaRoute: "/app/onboarding",
  },
  "next-step-chat-v1": {
    id: "next-step-chat-v1",
    requiredStage: ["onboarding_complete", "activated"],
    routes: ["/app"],
    title: "Start your first chat",
    description: "Open a section in the sidebar and click New Chat to get AI-powered fundraising guidance.",
  },
};

export const BANNER_LIST = Object.values(BANNERS);
